import { BrandThemeConfig } from './types';
import { cssBrandTokens } from './brandTokens';
import { BRAND_ENV } from './brandEnv';

/** Hardcoded Hale logo (web + mobile) */
export const HALE_DEFAULT_LOGO_URL =
  'https://www.haleeducation.com/wp-content/uploads/2024/05/hale-education-logo-blue.png';

export const HALE_FAVICON_URL =
  'https://asset.sparkl.me/pb/assets/img/hale_logo_mob.png';

export const HALE_TERMS_URL =
  'https://www.haleeducation.com/terms-conditions/';

export const HALE_PRIVACY_URL =
  'https://www.haleeducation.com/privacy-policy/';

export const HALE_MOBILE = '+971 58 864 7486';

/**
 * Hale runtime config. Visual styling tokens live in public/themes/hale.css.
 * cssVariables here are only what MUI theme creation needs at init time.
 */
export const haleBrandConfig: BrandThemeConfig = {
  key: 'hale',
  name: 'Hale Education',
  buId: BRAND_ENV.hale.buId,
  appId: BRAND_ENV.hale.appId,
  fontFamily: 'Inter',
  palette: {
    primary: '#0b2545',
    secondary: '#d4af37',
    accent: '#122e52',
    green: '#0b2545',
    yellow: '#d4af37',
  },
  tokens: cssBrandTokens,
  cssVariables: {
    '--brand-background': '#ffffff',
    '--brand-surface': '#f4f5f9',
    '--brand-text': '#0b2545',
    '--brand-font-family': 'Inter, sans-serif',
    '--brand-empty-state-bg': 'color-mix(in oklab, #CBA052 10%, transparent)',
  },
};
